import { render, staticRenderFns } from "./listing-box-description.vue?vue&type=template&id=7bd5f9cd&"
import script from "./listing-box-description.vue?vue&type=script&lang=js&"
export * from "./listing-box-description.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports